import React, { useCallback, useContext, useEffect, useRef, useState } from 'react'
import { BULK_DELETE, CREATE_PARENT, CREATE_UPDATE, DELETE_SELECTED, DOWNLOAD_ALL_AS_XLS, DOWNLOAD_TEMPLATE, MOVE_TO_PARENT, PARENT_CHILD, PDW_CREATE, PDW_UPDATE, PDW_VALIDATE, PUBLISH_SELECTED, PUBLISH_UNPUBLISH, RECATEGORIZE, REMOVE_CHILD, UNPUBLISH_SELECTED, UPLOAD, UPLOAD_XLS, VIEW_LOGS } from '../ProductConstants'
import { TChildSelected, TProductSelected } from 'types/Pages/ProductDelta';
import Utils from 'Common/Utils';
import { toast } from 'react-toastify';
import { checkJobStatus } from 'api/Job';
import { downloadReversePDW } from 'api/Pdw';
import { AppContext } from 'Context/AppContext';
import { ProductsContext } from '../ProductsContext';
import { TFilters } from 'types/hooks/useTable';

type TDialogProps = {
  filters: TFilters,
  onOpen: () => void;
  onOpenCreateParent: () => void;
  productsSelected: TProductSelected
  childSelected: TChildSelected
  openDeleteModal: () => void
  onOpenCreateModal: () => void;
  onOpenUpdateModal: () => void;
  onOpenValidateModal: () => void;
  onOpenRecategorizeModal: () => void;
  onOpenLogsModal: () => void;
  onOpenTemplateModal: () => void;
  downloadTemplate: () => void;
  openBulkDeleteXLSModal: () => void;
}

export const BulkAction = ({ filters, productsSelected, childSelected, openDeleteModal, onOpenCreateModal, onOpenUpdateModal, onOpenValidateModal, onOpenRecategorizeModal, onOpenLogsModal, onOpenTemplateModal, downloadTemplate, openBulkDeleteXLSModal }: TDialogProps) => {
  const [showMenu, setShowMenu] = useState<boolean>(false);
  const [downloadUrl, setDownloadUrl] = useState<string | undefined>(undefined)
  const appData = useContext(AppContext)
  const industryid = appData?.selectedIndustry && appData.selectedIndustry.id;
  const channelKey = appData?.channelKey;
  const prodContext = useContext(ProductsContext);
  const createPermission = appData.pm.checkPermission("gmsproducts_create");
  const updatePermission = appData.pm.checkPermission("gmsproducts_update");
  const deletePermission = appData.pm.checkPermission("gmsproducts_delete");
  const recategorizePermission = appData.pm.checkPermission("gmsproducts_recategorize");


  const ref = useRef<HTMLDivElement>(null);

  const handleClickOutside = useCallback(
    (e: MouseEvent) =>
      Utils.run_callback_on_click_outside_ref(e, ref, () => setShowMenu(false)),
    [ref]
  );

  useEffect(() => {
    // close dropdown if clicked outside
    showMenu
      ? document.addEventListener("mousedown", handleClickOutside)
      : document.removeEventListener("mousedown", handleClickOutside);
    return () => {
      document.removeEventListener("mousedown", handleClickOutside);
    };
  }, [ref, handleClickOutside, showMenu]);

  /**
   * get the XLS using the current filters
   */
  async function downloadPDW() {
    const attributeString = filters?.filters?.join(',') ?? ""
    setDownloadUrl(undefined);
    if (!channelKey) return
    const result = await downloadReversePDW(industryid, channelKey, prodContext.selected_Category.id as string, attributeString)

    toast.info("Making request");
    if (!result[0]) return

    checkJobStatus(result[1]?.jobid as string)
      .then((jobdata: any) => {
        setDownloadUrl(jobdata.data)
        setTimeout(() => {
          setDownloadUrl(undefined);
        }, 4000)
      })
      .catch((err) => {
        console.error(err)
      })
  }

  const handleClick = (callback?: Function) => {
    callback && callback()
    setShowMenu((prev) => !prev);
  }

  const labelClassName = "tw-block tw-px-4 tw-py-1 tw-font-bold tw-text-xs tw-text-[#A4A8AF]"
  const linkClassName = "tw-block tw-px-4 tw-py-1 tw-text-sm tw-text-black hover:tw-bg-lightblue tw-w-full tw-text-left"
  const linkDisabledClassName = "!tw-text-gray-200 tw-pointer-events-none"
  const parentOptionsDisabledClass = (productsSelected.length === 0 && childSelected.length === 0) ? linkDisabledClassName : ''

  return (
    <div ref={ref}>
      <button className={`${showMenu ? "tw-bg-[#EBECF0]" : ""} hover:tw-bg-[#EBECF0] tw-rounded-[4px]  tw-text-sm tw-font-normal tw-text-[#172B4D] tw-p-2`} onClick={() => handleClick()}>Bulk Action</button>
      {showMenu ? (
        <div className={`tw-origin-top-right tw-absolute tw-right-0 tw-w-48 tw-mx-3 tw-rounded-[4px] tw-bg-white tw-ring-1 tw-ring-[#EBECF0]`}>
          <div className={`tw-py-1`} role="menu" aria-orientation="vertical" aria-labelledby="options-menu">
            {/* <label className={labelClassName}>{PARENT_CHILD}</label>
          <button type="button" onClick={() => {if (createPermission) {handleClick(onOpenCreateParent); } else {toast.info("You don't have permission to Create a Parent.")} }} className={`${linkClassName} ${productsSelected.length === 0 && linkDisabledClassName}`} role="menuitem">{CREATE_PARENT}</button>
          <button type="button" onClick={() => {if (updatePermission) {handleClick(onOpen); } else {toast.info("You don't have permission to Move to Parent.")} }} className={`${linkClassName} ${parentOptionsDisabledClass}`} role="menuitem">{MOVE_TO_PARENT}</button>
          <button type="button" onClick={() => { if (deletePermission) { handleClick(() => prodContext.setRemoveChildModal(true));} else {toast.info("You don't have permission to Remove a Child.")}}} className={`${linkClassName} ${childSelected.length === 0 && linkDisabledClassName}`} role="menuitem">{REMOVE_CHILD}</button>
          <div className={`tw-box-border tw-w-auto tw-h-px tw-border-t-[1px] tw-border-solid tw-border-[#D1D1D6]`} />   */}

            {/* <label className={`tw-block tw-px-4 tw-py-1 tw-font-bold tw-text-xs tw-text-[#A4A8AF]`}>{PUBLISH_UNPUBLISH}</label>  
          <Link to="#" className={`tw-block tw-px-4 tw-py-1 tw-text-sm tw-text-black hover:tw-bg-lightblue`} role="menuitem">{PUBLISH_SELECTED}</Link>
          <Link to="#" className={`tw-block tw-px-4 tw-py-1 tw-text-sm tw-text-black hover:tw-bg-lightblue`} role="menuitem">{UNPUBLISH_SELECTED}</Link>
          <div className={`tw-box-border tw-w-auto tw-h-px tw-border-t-[1px] tw-border-solid tw-border-[#D1D1D6]`} />   */}
            <label className={`tw-block tw-px-4 tw-py-1 tw-font-bold tw-text-xs tw-text-[#A4A8AF]`}>{CREATE_UPDATE}</label>
            <button type="button" onClick={() => { if (createPermission) { handleClick(onOpenCreateModal); } else { toast.info("You don't have permission to Create the products.") } }} className={linkClassName} role="menuitem">{PDW_CREATE}</button>
            <button type="button" onClick={() => { if (updatePermission) { handleClick(onOpenUpdateModal); } else { toast.info("You don't have permission to Update the Products.") } }} className={linkClassName} role="menuitem">{PDW_UPDATE}</button>
            <button type="button" onClick={() => { if (updatePermission) { handleClick(onOpenValidateModal); } else { toast.info("You don't have permission to Update the products") } }} className={linkClassName} role="menuitem">{PDW_VALIDATE}</button>
            <button type="button" disabled={recategorizePermission} onClick={() => { if (recategorizePermission) { handleClick(onOpenRecategorizeModal); } else { toast.info("You don't have permission to Recategorize the products") } }} className={`${linkClassName} ${parentOptionsDisabledClass}`} role="menuitem">{RECATEGORIZE}</button>
            <button type="button" onClick={() => handleClick(downloadPDW)} className={linkClassName} role="menuitem">{DOWNLOAD_ALL_AS_XLS}</button>
            <button type="button" onClick={() => handleClick(onOpenTemplateModal)} className={linkClassName} role="menuitem">{DOWNLOAD_TEMPLATE}</button>
            <button type="button" onClick={() => handleClick(onOpenLogsModal)} className={linkClassName} role="menuitem">{VIEW_LOGS}</button>
            <div className={`tw-box-border tw-w-auto tw-h-px tw-border-t-[1px] tw-border-solid tw-border-[#D1D1D6]`} />
            <label className={labelClassName}>{BULK_DELETE}</label>
            <button type="button" onClick={() => { if (deletePermission) { handleClick(openDeleteModal); } else { toast.info("You don't have permission to delete the product.") } }} className={`${linkClassName} ${parentOptionsDisabledClass}`} role="menuitem">{DELETE_SELECTED}</button>
            <button type="button" onClick={() => { if (updatePermission) { handleClick(openBulkDeleteXLSModal); } else { toast.info("You don't have permission to Delete the products") } }} className={linkClassName} role="menuitem">{UPLOAD_XLS}</button>
            <button type="button" onClick={() => handleClick(downloadTemplate)} className={linkClassName} role="menuitem">{DOWNLOAD_TEMPLATE}</button>
          </div>
        </div>
      ) : null}
      <iframe
        style={{ display: "none" }}
        src={downloadUrl}
        id="iframe_pdw_download"
        title="pdw_download_create"
      />
    </div>
  )
}
